import Step0Content from "pages/login/_components/Step0Content";
import { func, string } from "prop-types";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { actions as loginActions, selectors as loginSelectors } from "reducers/login";
import { selectors as momentDaySelectors } from "reducers/momentDay";
import * as config from "util/config";
import { isIOSPlatform, isMobileNativeFunc } from "util/device";
import { validatePermissionMobile } from "util/permissions/permission.util";
import { selectors as fingerprintSelectors } from "reducers/fingerprint";
import { getMobileTagManagetId } from "util/tagManager/tagManager.util";
import TagManager from "react-gtm-module";

const Login = (props) => {
    const { momentDay, dispatch } = props;

    const [initialized, setInitialized] = useState(false);

    const checkInitialization = () => {
        if (!initialized && momentDay) {
            dispatch(loginActions.initLoginFlow());
            setInitialized(true);
            window.common.hideSplashScreen();
        }
    };

    const initMobileGoogleTagManager = () => {
        if (!isMobileNativeFunc()) {
            return;
        }

        const gtmId = getMobileTagManagetId(config);
        if (!gtmId || gtmId === "") {
            // eslint-disable-next-line no-console
            console.log("Google tag manager id, not found");
            return;
        }

        TagManager.initialize({
            gtmId,
            events: {
                sendUserInfo: "userInfo",
            },
        });
    };

    const init = () => {
        dispatch(loginActions.cancelLoginStep1());
        dispatch(loginActions.cancelLoginStep3());
        validatePermissionMobile();
        checkInitialization();
        initMobileGoogleTagManager();
    };
    const validateProminentDisclosurePlugin = () => {
        try {
            const titleContact = config.get("prominent.disclosure.request.permission.title") ?? "Aviso de seguridad";
            const descriptionContact =
                config.get("prominent.disclosure.request.permission.desc") ??
                "Comprometidos con la seguridad y confidencialidad de su información, Banesco N.V. recopila información sobre aplicaciones instaladas en tu dispositivo móvil, lo que permite la protección de sus datos ante posibles eventos de fraude o actividades sospechosas. Esta acción es completamente con fines de seguridad y no es compartida con terceros";

            const body = [
                {
                    imageType: "RESOURCE",
                    imageResId: "ic_contact",
                    title: titleContact,
                    description: descriptionContact,
                },
            ];

            window.cordova.plugins.ProminentDisclosurePlugin.showPrompt(
                JSON.stringify(body),
                () => {
                    init();
                },
                () => {
                    navigator.app.exitApp();
                },
            );
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
        }
    };

    const validatePlatform = () => {
        if (!isMobileNativeFunc()) {
            init();
            return;
        }

        if (isIOSPlatform()) {
            init();
            return;
        }

        validateProminentDisclosurePlugin();
    };

    useEffect(() => {
        validatePlatform();
    }, []);

    return (
        <>
            <Step0Content />
        </>
    );
};

const mapStateToProps = (state) => ({
    momentDay: momentDaySelectors.getMomentDay(state) || "",
    rememberedUser: loginSelectors.getRememberedUser(state),
    device: fingerprintSelectors.getDevice(state),
});

Login.propTypes = {
    momentDay: string.isRequired,
    dispatch: func,
};

Login.defaultProps = {
    dispatch: () => {},
};

export default withRouter(connect(mapStateToProps)(Login));
